import { createContext } from "react";

interface GoogleMapContextType {
  isLoaded: boolean;
}

export const GoogleMapContext = createContext<GoogleMapContextType>({
  isLoaded: false,
});
